module.exports = __webpack_public_path__ + "static/media/loader.5f7b1f32.gif";